import React from 'react';
import { Card, Avatar, Typography, Space, Button, Image } from 'antd';
import { UserOutlined, GithubOutlined, MailOutlined, EnvironmentOutlined, HeartOutlined, BookOutlined, CoffeeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Paragraph, Text } = Typography;

const About = () => {
  const navigate = useNavigate();
  
  const skills = [
    { name: 'React', level: 90, color: '#61DAFB' },
    { name: 'JavaScript', level: 85, color: '#F7DF1E' },
    { name: 'CSS/HTML', level: 95, color: '#1572B6' },
    { name: 'Node.js', level: 75, color: '#339933' },
    { name: 'UI/UX设计', level: 80, color: '#FF6B6B' },
    { name: '摄影', level: 70, color: '#4ECDC4' },
  ];

  const interests = [
    { icon: <BookOutlined />, text: '阅读与写作', color: '#36D1DC' },
    { icon: <CoffeeOutlined />, text: '精品咖啡', color: '#8B4513' },
    { icon: <EnvironmentOutlined />, text: '城市探索', color: '#FF9A8B' },
    { icon: <HeartOutlined />, text: '户外徒步', color: '#4CAF50' },
  ];

  return (
    <div className="about-page">
      {/* 返回按钮 - 放在页面顶部 */}
      <div className="about-back-button">
        <Button 
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          type="text"
          className="back-btn"
        >
          返回
        </Button>
      </div>
      
      <Card className="about-card">
        {/* 头部区域 */}
        <div className="about-header">
          <Avatar 
            size={120} 
            src="/IMG_background.jpg" 
            className="about-avatar"
          />
          <div className="about-title">
            <Title level={2} className="main-title">你好，我是文艺生活家yskkkk ✨</Title>
            <Text type="secondary" className="subtitle">前端开发者 • 摄影爱好者 • 咖啡探索者</Text>
          </div>
        </div>
        
        <div className="about-content">
          <section className="about-section">
            <Title level={3} className="section-title">
              <span className="title-icon">📖</span> 关于这个博客
            </Title>
            <Paragraph className="section-paragraph">
              欢迎来到我的个人空间！这里是我记录生活、分享思考和探索技术的角落。我相信技术应该服务于生活，让生活变得更美好、更有趣。
            </Paragraph>
            <Paragraph className="section-paragraph">
              在这里，你会看到关于前端技术的实践分享、生活中的小发现、旅行见闻，以及那些让我心动的美好瞬间。我希望通过这个平台，与更多有趣的人交流，共同成长。
            </Paragraph>
          </section>
          
          
          <section className="about-section">
            <Title level={3} className="section-title">
              <span className="title-icon">⚡</span> 技能与专长
            </Title>
            <div className="skills-container">
              {skills.map((skill, index) => (
                <div key={skill.name} className="skill-item">
                  <div className="skill-header">
                    <span className="skill-name">{skill.name}</span>
                    <span className="skill-percent">{skill.level}%</span>
                  </div>
                  <div className="skill-bar">
                    <div 
                      className="skill-progress"
                      style={{ 
                        width: `${skill.level}%`,
                        backgroundColor: skill.color,
                        animationDelay: `${index * 0.1}s`
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </section>
          
          <section className="about-section">
            <Title level={3} className="section-title">
              <span className="title-icon">❤️</span> 生活兴趣
            </Title>
            <div className="interests-grid">
              {interests.map((interest, index) => (
                <div 
                  key={interest.text} 
                  className="interest-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="interest-icon" style={{ color: interest.color }}>
                    {interest.icon}
                  </div>
                  <span className="interest-text">{interest.text}</span>
                </div>
              ))}
            </div>
          </section>
          
          <section className="about-section">
            <Title level={3} className="section-title">
              <span className="title-icon">📬</span> 找到我
            </Title>
            <div className="contact-section">
              <Space direction="vertical" size="middle" className="contact-info">
                <div className="contact-item">
                  <EnvironmentOutlined className="contact-icon" />
                  <span>📍 城市漫游中</span>
                </div>
                <div className="contact-item">
                  <MailOutlined className="contact-icon" />
                  <span>📧 hello@example.com</span>
                </div>
              </Space>
              
              <div className="social-links">
                <Button 
                  type="primary" 
                  icon={<GithubOutlined />}
                  href="https://github.com"
                  target="_blank"
                  className="social-btn github-btn"
                >
                  GitHub
                </Button>
                <Button 
                  icon={<MailOutlined />}
                  href="mailto:hello@example.com"
                  className="social-btn email-btn"
                >
                  发送邮件
                </Button>
              </div>
            </div>
          </section>
          
          <div className="quote-section">
            <div className="quote-icon">"</div>
            <Paragraph className="quote-text">
              生活不是等待暴风雨过去，而是学会在雨中跳舞。
            </Paragraph>
            <Text type="secondary" className="quote-author">- 保持好奇，保持热爱 -</Text>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default About;